import c from 'classnames';
import { useDeviceInfo } from 'core/components/DeviceInfoContext';
import useToggle from 'core/hooks/useToggle';
import injectSheet from 'core/style/injectSheet';
import { WithStyles } from 'core/style/interfaces';
import { formatNumberToDecimal } from 'core/utils';
import React from 'react';
import Graph from 'site/components/high-low/Graph';
import { securityStyles } from 'site/components/high-low/Security';
import SecurityInfoModal from 'site/components/high-low/SecurityInfoModal';
import { GetDividendDetailQuery } from 'site/graphql';
import InfoIcon from '../../../svg/info.svg';

type IDividendDetailSecurityProps = {
    security: GetDividendDetailQuery['dividend']['security'];
} & WithStyles<typeof securityStyles>;

const DividendDetailSecurity: React.FC<IDividendDetailSecurityProps> = ({ classes, security }) => {
    const { d1, w1, m1, y1, yTD } = security;
    const { isMobile } = useDeviceInfo();
    const [toggle, { onToggle, offToggle }] = useToggle();
    const renderPercent = (value: number) => (
        <div
            className={c(classes.percent, {
                [classes.percentRed]: value < 0,
                [classes.percentGreen]: value > 0,
            })}
        >
            {formatNumberToDecimal(value)}%
        </div>
    );

    return (
        <>
            <div className={classes.root}>
                {!isMobile && (
                    <div className={classes.leftHeader}>
                        <div className={classes.leftHeaderGraph}>
                            <div>Low</div>
                            <div />
                            <div>High</div>
                        </div>
                    </div>
                )}
                <div className={classes.header}>
                    <div>1D</div>
                    <div>1W</div>
                    <div>1M</div>
                    <div>YTD</div>
                    <div>1Y</div>
                </div>
                <Graph security={security} />
                <div className={classes.percents}>
                    {renderPercent(d1)}
                    {renderPercent(w1)}
                    {renderPercent(m1)}
                    {renderPercent(yTD)}
                    {renderPercent(y1)}
                </div>
                <InfoIcon className={classes.infoIcon} onClick={onToggle} />
                <SecurityInfoModal isOpen={toggle} onCloseModal={offToggle} security={security} />
            </div>
        </>
    );
};

export default injectSheet(securityStyles)(DividendDetailSecurity);
